/* unplugin-vue-components disabled */import script from "./anchor-box-home.vue?vue&type=script&lang=jsx"
export * from "./anchor-box-home.vue?vue&type=script&lang=jsx"

import "./anchor-box-home.vue?vue&type=style&index=0&id=5aae9b00&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aae9b00"]])

export default __exports__